var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group" },
    [
      _c("geo-autocomplete", {
        attrs: {
          config: _vm.config,
          config_map: _vm.config_map,
          contract: _vm.contract,
          districts: _vm.districts,
          filters: _vm.filters,
          placeholder: _vm.placeholder,
          city: _vm.city,
          searchData: _vm.searchData,
          section: _vm.section,
          sector: _vm.sector
        },
        on: {
          input: function($event) {
            return _vm.$emit("input", _vm.value)
          },
          "show-districts": _vm.showDistricts,
          "hide-districts": _vm.hideDistricts
        },
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      }),
      _vm._v(" "),
      _c(
        "keep-alive",
        [
          _vm.show_districts
            ? _c("districts-list", {
                attrs: {
                  config: _vm.config,
                  config_map: _vm.config_map,
                  city: _vm.city,
                  searchData: _vm.searchData,
                  contract: _vm.contract,
                  districts: _vm.districts,
                  sector: _vm.sector,
                  section: _vm.section
                },
                on: { "hide-districts": _vm.hideDistricts },
                model: {
                  value: _vm.form.districts,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "districts", $$v)
                  },
                  expression: "form.districts"
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }